(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coming-soon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('coming-soon-countdown')) {
    class ComingSoonCountdown extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.target).getTime();
        this.daysEl = this.querySelector('[data-days]');
        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        if (Number.isNaN(this.target)) return;

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        const distance = this.target - Date.now();

        if (distance <= 0) {
          clearInterval(this.interval);
          this.setAttribute('data-ended', 'true');
          return;
        }

        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance / 3600000) % 24);
        const minutes = Math.floor((distance / 60000) % 60);
        const seconds = Math.floor((distance / 1000) % 60);

        this.daysEl.textContent = String(days).padStart(2, '0');
        this.hoursEl.textContent = String(hours).padStart(2, '0');
        this.minutesEl.textContent = String(minutes).padStart(2, '0');
        this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('coming-soon-countdown', ComingSoonCountdown);
  }

  if (
    window.matchMedia('(pointer: fine)').matches &&
    window.matchMedia('(prefers-reduced-motion: no-preference)').matches
  ) {
    window.addEventListener('pointermove', (event) => {
      document.querySelectorAll('[data-coming-soon-parallax]').forEach((root) => {
        const rect = root.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        root.style.setProperty('--mx', x.toFixed(3));
        root.style.setProperty('--my', y.toFixed(3));
      });

      document.querySelectorAll('[data-coming-soon-tilt]').forEach((el) => {
        const rect = el.getBoundingClientRect();
        const relX = (event.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
        const relY = (event.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
        const clampedX = Math.max(-1, Math.min(1, relX));
        const clampedY = Math.max(-1, Math.min(1, relY));
        el.style.setProperty('--tilt-x', (clampedX * 12).toFixed(2));
        el.style.setProperty('--tilt-y', (-clampedY * 12).toFixed(2));
      });
    });

    document.querySelectorAll('[data-coming-soon-magnetic]').forEach((magnet) => {
      magnet.addEventListener('pointermove', (event) => {
        const rect = magnet.getBoundingClientRect();
        const x = event.clientX - (rect.left + rect.width / 2);
        const y = event.clientY - (rect.top + rect.height / 2);
        magnet.style.setProperty('--magnet-x', `${(x * 0.25).toFixed(1)}px`);
        magnet.style.setProperty('--magnet-y', `${(y * 0.25).toFixed(1)}px`);
      });

      magnet.addEventListener('pointerleave', () => {
        magnet.style.setProperty('--magnet-x', '0px');
        magnet.style.setProperty('--magnet-y', '0px');
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
